import { Header } from '../../components/common';
import { StatsFilter } from './components/StatFilter/StatsFilter';
import React, { useState, useEffect, useCallback } from 'react';
import './statsPage.css';
import { StatWidget } from './components/StatWidget/StatWidget';
import axios from 'axios';
import { getToken } from '../../utils/token';
import DriveFolderUploadOutlinedIcon from '@mui/icons-material/DriveFolderUploadOutlined';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import CurrencyRubleOutlinedIcon from '@mui/icons-material/CurrencyRubleOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import { PaymentStatWidget } from './components/PaymentStatWidget/PaymentStatWidget';
import { CircularProgress } from '@mui/material';
import iziToast from 'izitoast';
import { internalServerError } from '../../utils/consts/pathRoutes';

const getDefaultDateRange = () => {
  const today = new Date();
  const day = today.getDay();
  const daysToSubtract = day === 5 ? 7 : (day + 2) % 7;
  const lastFriday = new Date(today);

  lastFriday.setDate(today.getDate() - daysToSubtract);
  return [lastFriday, today];
};

export const StatsPage = () => {
  const [dateRange, setDateRange] = useState(getDefaultDateRange());
  const [academicYear, setAcademicYear] = useState('26-27');
  const [statsData, setStatsData] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchStats = useCallback(async (overrides = {}) => {
    setLoading(true);
    try {
      const fromDate = overrides.from ?? dateRange[0];
      const toDate = overrides.to ?? dateRange[1];
      const year = overrides.year ?? academicYear;

      const response = await axios.get(`${process.env.REACT_APP_URL_PATH}/api/student/combinedStats`, {
        headers: {
          'Authorization': getToken(),
          'Content-Type': 'application/json;charset=utf-8'
        },
        params: {
          from: fromDate.toISOString().split('T')[0],
          to: toDate.toISOString().split('T')[0],
          year: year,
        },
      });
      setStatsData(response.data);
    } catch (error) {
      iziToast.error({
        message: internalServerError(error),
        position: "topRight",
        color: "#FFF2ED"
      });
      console.error('Failed to fetch stats:', error);
    } finally {
      setLoading(false);
    }
  }, [dateRange, academicYear]);

  useEffect(() => {
    fetchStats();
  }, []);

  const handleReset = () => {
    const defaults = getDefaultDateRange();
    setDateRange(defaults);
    setAcademicYear('26-27');
    fetchStats({ from: defaults[0], to: defaults[1], year: '26-27' });
  };

  const handleApply = () => {
    console.log('Applied date range:', dateRange);
    console.log('Selected academic year:', academicYear);
    fetchStats();
  };

  const formatCurrency = (value) => {
    if (value === undefined || value === null) return `0\u00A0₽`;
    return `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0')}\u00A0₽`;
  };

  return (
    <>
      <Header />
      <div className="statsBlock">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <StatsFilter
            dateRange={dateRange}
            onDateChange={setDateRange}
            onApply={handleApply}
            onReset={handleReset}
            academicYear={academicYear}
            onAcademicYearChange={setAcademicYear}
          />
          {loading && <CircularProgress color="warning" />}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div className="statsGrid">
            <StatWidget
              icon={DriveFolderUploadOutlinedIcon}
              title="Документы, переданные в международную службу"
              value={statsData.transferredCount ?? 0}
              subLabel="Дата передачи в международную службу"
            />
            <StatWidget
              icon={MarkEmailReadOutlinedIcon}
              title="Полученные и отправленные приглашения"
              value={statsData.invitationCount ?? 0}
              subLabel="Фактическая дата получения приглашения"
            />
            <StatWidget
              icon={CurrencyRubleOutlinedIcon}
              title="Количество оплат"
              value={statsData.paymentCount ?? 0}
              subLabel="1, 2, 3 и 4 фактические платежи за промежуток"
            />
          </div>
          <div style={{ display: 'flex', margin: 'auto'}}>
            <PaymentStatWidget
              icon={MonetizationOnOutlinedIcon}
              title="Суммарная оплата по всем платежам"
              value={formatCurrency(statsData.paymentSummary?.totalSum)}
              subLabel="Сумма 1, 2, 3 и 4 фактических платежей"
              paid={statsData.paymentSummary?.paymentStatusCounts['Оплачено'] ?? 0}
              unpaid={statsData.paymentSummary?.paymentStatusCounts['Не оплачено'] ?? 0}
              partial={statsData.paymentSummary?.paymentStatusCounts['Оплачено частично'] ?? 0}
              bottomRightLabel="Статус оплаты"
            />
          </div>
        </div>
      </div>
    </>
  );
};
